export default __webpack_public_path__ + "graphics/american-express.a721b26f.jpg";